export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

// Example input
// jsonObjects = {
//   object1: [
//     { name: "John", age: 30, city: "New York" },
//     { name: "John", age: 30, city: "New York" },
//     { name: "John", age: 30, city: "New York" },
//   ],
//   object2: [
//     { product: "Laptop", price: 1200, brand: "Dell" },
//     { product: "Laptop", price: 1200, brand: "Dell" },
//     { product: "Laptop", price: 1200, brand: "Dell" },
//   ],
// }
export const jsonObjectsToCSV = (jsonObjects) => {
  let csvContent = "";

  // Iterate over each key in the parent object
  for (const key in jsonObjects) {
    if (jsonObjects.hasOwnProperty(key)) {
      const records = jsonObjects[key];

      if (Array.isArray(records) && records.length > 0) {
        // Get headers from the first record
        const headers = Object.keys(records[0]);

        // Add headers to the CSV
        csvContent += headers.join(", ") + ",\n";

        // Add data rows
        // Add data rows
        records.forEach((record) => {
          const dataRow = headers.map((header) => {
            const value = record[header];

            // Handle strings with commas by wrapping them in quotes
            if (typeof value === "string" && value.includes(",")) {
              return `"${value.replace(/"/g, '""')}"`; // Escape quotes within the string
            }

            return value;
          });

          csvContent += dataRow.join(", ") + ",\n";
        });

        // Add an empty line to separate objects
        csvContent += "\n";
      }
    }
  }

  return csvContent;
}




